export enum ProductBadgeEnum{
    AllProduct = "All product",
    NewProduct="New product",
    RecommendProduct="Recommend product"
}